import { DATA_STATUS_LABEL, METHOD_LABEL, STAGE_LABEL, VALUE_TYPE_LABEL, type DataStatus, type MethodId, type Stage, type ValueType } from "@h2lca/core";
import { efStatusLabel } from "./helpers";

/** 단계 배지 , 색은 workshop.css 의 data-stage 규칙이 정한다 */
export function StageBadge({ stage }: { stage: Stage }) {
  return (
    <span className="stage-badge" data-stage={stage}>
      {STAGE_LABEL[stage]}
    </span>
  );
}

/** 값 유형 배지 , 자료 미입력만 위험색, 추정값은 경고색 */
export function ValueTypeBadge({ valueType }: { valueType: ValueType | string }) {
  const vt = valueType as ValueType;
  const tone = vt === "missing" ? " badge-danger" : vt === "estimated" ? " badge-warn" : "";
  return <span className={`badge-soft${tone}`}>{VALUE_TYPE_LABEL[vt] ?? valueType}</span>;
}

/** 배출계수 자료 상태 배지 */
export function EfStatusBadge({ status }: { status: DataStatus | string }) {
  const { label, tone } = efStatusLabel(status);
  const cls = tone === "warn" ? " badge-review" : tone === "ok" ? " badge-ok" : "";
  return <span className={`badge-soft${cls}`}>{DATA_STATUS_LABEL[status as DataStatus] ?? label}</span>;
}

/** 산정방식 배지 , 인증제는 강조, 일반은 무채 */
export function MethodBadge({ method, long = false }: { method: MethodId; long?: boolean }) {
  const label = long ? METHOD_LABEL[method] : method === "cert" ? "인증제 모의산정" : "일반 LCA";
  return <span className={method === "cert" ? "badge-accent" : "badge-soft"}>{label}</span>;
}

/** 계산 상태 배지 */
export function StatusBadge({ status }: { status: "ok" | "blocked" }) {
  return status === "ok" ? <span className="badge-soft badge-ok">계산 가능</span> : <span className="badge-soft badge-danger">계산 제한</span>;
}
